import { Form } from 'antd';
import React from 'react';
import { fieldNames } from '../../../common/config';
import DispexInput from '../../../../../../../components/DispexInput';

const flatCountFieldName = fieldNames.flatCount;
const FormItem = Form.Item;

const CountFlat = ({ form }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        justifyContent: 'start',
        marginTop: 10,
      }}
    >
      <div>Количество помещений:</div>
      <FormItem style={{ margin: 0 }}>
        {form.getFieldDecorator(flatCountFieldName)(
          <DispexInput
            placeholder="2"
            type="number"
            min={1}
          />
        )}
      </FormItem>
    </div>
  );
};

export default CountFlat;
